define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var renderTooltip = function (text, $for) {
        var $tip = $('.screen-tooltip');
        if ($tip.length === 0) {
            $tip = $('<div class="screen-tooltip"><div class="body"></div><div class="tip-nub"></div></div>').appendTo($('body'));
        }
        $tip.find('.body').text(text);
        $tip.appendTo($for);
    };
    exports["default"] = renderTooltip;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/tooltip.js
// module id = 51
// module chunks = 0